<!--RECOMMENDED FOUNDATIONAL COURSES-->
<app-card-container
  [title]="title"
  [showTitle]="showViewAllCourses"
  [showDescription]="showViewAllCourses"
  description="{{ description }}">
  <!--VIEW ALL COURSES BUTTON-->
  <!--NOTE: Clicking on View All Courses redirects to the catalog search page with the related courses to the selected subscription-->
  <ng-container *ngIf="showViewAllButton">
    <span class="flexbox justify-content-center text-align-center">
      <div class="action-button">
        <button
          id="view-all-courses-{{ selectedSubscriptionSlug }}"
          attr.data-beyond-button-id="view-all-courses-{{ selectedSubscript'ionSlug }}"
          class="btn btn-primary margin-bottom-large larger-btn padding-right-small"
          (click)="onClick()">
          View All Courses
        </button>
      </div>
    </span>
  </ng-container>
  <!--END VIEW ALL COURSES BUTTON-->

  <!--NOTE: Pass in custom cards into the card container ngcontent-->
  <div
    [ngClass]="courses && courses.length > 0 ? 'tile-layout-' + courses.length : ''"
    #cardContainer>
    <!--RECOMMENDED FOUNDATIONAL COURSES LIST-->
    <!--NOTE: Each subscription has 3 recommend courses and 1 recommended certification exam-->
    <ng-container *ngIf="courses && courses.length > 0">
      <app-card
        *ngFor="let course of courses; let i = index; trackBy: trackByCourseId"
        [id]="course.id"
        [cardType]="course.instructionType | cardType"
        [cardSubType]="course.instructionType | cardSubType"
        [instructionType]="course.instructionType"
        [courseDuration]="
          course.instructionType
            | formatDuration : course.courseDuration : course.courseDurationMins
        "
        [title]="course.name"
        [showSubTitle]="course.instructionType | showCardSubHeaderTitle : course.isFreeCourse"
        route="{{ 'course/' + course.slugName }}"
        [routeType]="
          course.instructionType
            | cardTypeCallToActions
              : currentUser
              : course.subscriptionId
              : parentSubscriptionId
              : course.id
              : course.isFreeCourse
              : course.relatedCourseIds
            | routeTypesByCallToActions : course.instructionType : true
        "
        [buttonRoute]="
          currentUser
            | courseTypeRoute
              : course.instructionType
              : course.slugName
              : course.id
              : 'subscription'
              : course.subscriptionSlugName
        "
        (sendClick)="
          sendGoogleAnalytics('Recommended Foundational', 'click', course.slugName);
          loadEnrollELearning($event, course.instructionType, course.id)
        "
        [icon]="['info-icon', 'small', 'white']"
        [customHeaderCss]="course.instructionType | instructionTypeCustomHeader"
        [customCardHeightCss]="'card-max-height'"
        [customHeadingGroupCss]="'card-heading-group'"
        [customButtonCss]="course.instructionType | instructionTypeCustomButton"
        [informationTooltip]="
          [parentSubscriptionId] | courseSubscriptionTooltip : course.instructionType
        "
        [showTooltip]="true"
        [description]="course.description"
        [showButton]="showButton"
        actionLabel="{{
          course.instructionType
            | cardTypeCallToActions
              : currentUser
              : course.subscriptionId
              : parentSubscriptionId
              : course.id
              : course.isFreeCourse
              : course.relatedCourseIds
              : 'subscription'
        }}">
      </app-card>
    </ng-container>
    <!--END RECOMMENDED FOUNDATIONAL COURSES LIST-->
  </div>
</app-card-container>
<!--END RECOMMENDED FOUNDATIONAL COURSES-->
<!--REQUEST A QUOTE (VOUCHER) FORM-->
<app-modal-dialog [containerID]="'requestForm'" [modalMaxWidth]="'modal-max-width-medium'">
  <div #modalContainer>
    <app-request-form [formHeading]="cardTypeCallToActions.REQUEST_A_QUOTE"></app-request-form>
  </div>
</app-modal-dialog>
<!--END REQUEST A QUOTE (VOUCHER) FORM-->
